module.exports = __webpack_public_path__ + "img/m-icon7.fc9f6bae.png";